import React from "react";

import { setupActions } from '../actions';
import { connect } from 'react-redux'
import { Card,CardBody, Row, Col  } from "reactstrap";


import { Spinner } from 'components/Icons/Spinner';


import Select from "react-select";
import CollectionCrud from '../components/CollectionCrud';
import ParametersCrud from '../components/ParametersCrud';
const API = require ('Api') ;
var viewActions = require ('store/view.actions');

class ParamsConfig extends React.Component {

  parametersMap = [
    {
      value:'SYSPARAMS', 
      label: 'Parametros del sistema',
      endpoint: API.V2 + API.CONFIG + 'params'
      },

    {
      value:'FERIADOS', 
      label: 'Calendario de feriados',
      endpoint: API.V2 + API.SCHOOLS + 'holidays',
      useCalendar: true,
      cols: [
        { id: 'holiday_dt', title: 'Fecha', type:"DATE"}, 
        { id: 'description', title: 'Descripción', type:"STRING", align:"left"}
       ]
    }, 
    {
      value:'ATTENDANCE_TYPES', 
      label: 'Configuracion de Inasistencias',
      endpoint: API.V2 + API.CONFIG + 'attendancetypes',
      cols: [
        { id: 'type_id', title: 'ID', type:"STRING", align:"left"},
        { id: 'description', title: 'Descripcion', type:"STRING", align:"left"},
        { id: 'qty', title: 'Valor', type:"DECIMAL", align:"center"},
        { id: 'color', title: 'Color', type:"COLOR", align:"left"},
        { id: 'justification', title: 'Justif. Requerida', type:"YESNO", align:"left"}
       ]
    } 
  ]

  selectConfigGroup = ( sel ) => {
    this.setState({currentParameter: {...sel}})
    this.props.getCollection( this.props.token, this.props.currentCalendarID, sel );
  }
    //    const endpoint =  'config/params' ;
   
 
  
  componentDidMount() {
    this.props.setMainTitle( this.state.currentParameter.label, [] );
    this.props.getCollection( this.props.token, this.props.currentCalendarID, this.state.currentParameter );
  }

  constructor(props) {
    super(props);
    this.state = {
      currentParameter: this.parametersMap[0],

    }

 }

  render() {
    return (
      <>
        <div className="content">
        <Row>
          <Col md="12">
            <Card>
                <CardBody>
                    <Select
                        name="current"
                        defaultValue= { this.parametersMap[0]}
                        onChange={(sel) => this.selectConfigGroup(sel) }
                        options={this.parametersMap}
                        placeholder="Seleccione grupo de parámetros"
                      />
                  </CardBody>
              </Card>
        </Col>  
        </Row>
        {!this.props.view.loadingModules.getCollection && this.props.collection.length > 0 ?
          <Row>
            <Col md="12">
              { this.state.currentParameter.value==='SYSPARAMS'?
              
                <ParametersCrud
                  title={ this.state.currentParameter.label}
                  collection={this.props.collection}
                />
              :
                <CollectionCrud
                  title={ this.state.currentParameter.label}
                  collection={this.props.collection}
                  cols={ this.state.currentParameter.cols}
                />
            }
            </Col>
            
          </Row>
        :
        <Spinner size="XL" />
      }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        school: state.config.school,
        token: state.auth.session.jwt_token,
        collection: state.setup.collection 
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
      setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        getCollection: ( token, calendarID, collection ) => {
          dispatch( setupActions.getCollection( token, calendarID, collection )) ;
      } 
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(ParamsConfig);

